/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramGeoControllerGetTreeQueryResponse } from '../../types/TelegramGeoControllerGetTree.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoGetTree } from '../../methods/telegramGeoGetTree.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoGetTreeQueryKey = () => [{ url: '/api/telegram/geo/tree' }] as const;

export type TelegramGeoGetTreeQueryKey = ReturnType<typeof telegramGeoGetTreeQueryKey>;

export function telegramGeoGetTreeQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = telegramGeoGetTreeQueryKey();
  return queryOptions<
    TelegramGeoControllerGetTreeQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerGetTreeQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoGetTree(config);
    },
  });
}

/**
 * {@link /api/telegram/geo/tree}
 */
export function useTelegramGeoGetTree<
  TData = TelegramGeoControllerGetTreeQueryResponse,
  TQueryData = TelegramGeoControllerGetTreeQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoGetTreeQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerGetTreeQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoGetTreeQueryKey();

  const query = useQuery(
    {
      ...telegramGeoGetTreeQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
